<template>
  <UiTable
    :storage-id="storageId"
    :source-columns="columns"
    :rows="rows"
    :is-loading="isLoading"
    :pagination="{ 'page-index': page, 'page-size': pageSize }"
    :total="total"
    v-on="paginationListeners"
  />
</template>

<script>
import { ManagersService } from '@/services/managers.service'
import { redirectIfDenied } from '@/services/ability.service'

import tableDefaults from '@/components/table/tableDefaults'

import columns from './columns.js'

import UiTable from '@/components/table/UiTable.vue'
import syncQuery from '@/mixins/syncUrlQuery'

export default {
  components: { UiTable },
  mixins: [syncQuery, columns, tableDefaults],
  data() {
    return {
      storageId: 'managers-table',
    }
  },
  mounted() {
    this.syncQuery({ localField: 'pageSize', queryField: 'pageSize', query2local: (v) => +v })
    this.syncQuery({ localField: 'page', queryField: 'page', query2local: (v) => +v })

    this.getEmplyeesList()
  },
  created() {
    this.$bus.$on('refresh-managers-table', this.getEmplyeesList)
  },
  beforeDestroy() {
    this.$bus.$off('refresh-managers-table', this.getEmplyeesList)
  },
  methods: {
    /**
     * Send request to backend for get list of managers
     *
     * @returns {Object} data Response wrapper. Contains `content` and `total` parameters.
     * */
    async getEmplyeesList() {
      this.isLoading = true

      try {
        const { data } = await ManagersService.getList(this.colletQueryParams())

        this.rows = data.content.map((record) => Object.freeze(record))
        this.total = data.total
      } catch (e) {
        this.$store.commit('toast/NEW', { type: 'error', message: e.message, e })
        this.error = e.message

        redirectIfDenied.call(this, e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
